// extracted by mini-css-extract-plugin
export default {"container":"feedbackSelectedTags_container__6GsHg","tag":"feedbackSelectedTags_tag__XoIje"};